export const AUTH_LOADING = "AUTH_LOADING";
export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_FAILED = "SIGN_IN_FAILED";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const LOG_OUT = "LOG_OUT";
export const RESET_AUTH = "RESET_AUTH";
export const RESET_OTP = "OTP_RESET";
export const RESET_RESEND_OTP = "RESET_RESEND_OTP";

export const PAYOUT_AUTH_LOADING = "PAYOUT_AUTH_LOADING";
export const PAYOUT_LOG_OUT = "PAYOUT_LOG_OUT";
export const PAYOUT_SIGN_IN = "PAYOUT_SIGN_IN";
export const PAYOUT_SIGN_IN_FAILED = "PAYOUT_SIGN_IN_FAILED";

export const TRY_AGAIN = "TRY_AGAIN";

export const CREATE_MERCHANT_LOADING = "CREATE_MERCHANT_LOADING";
export const CREATE_MERCHANT_SUCCESS = "CREATE_MERCHANT_SUCCESS";
export const CREATE_MERCHANT_FAILD = "CREATE_MERCHANT_FAILD";
export const REMOVE_CREATE_MERCHANT = "REMOVE_CREATE_MERCHANT";

export const OTP_LOADING = "OTP_LOADING";
export const VERFIY_SUCCESS = "VERFIY_SUCCESS";
export const VERFIY_FAILD = "VERFIY_FAILD";

export const RESEND_LOADING = "RESEND_LOADING";
export const RESEND_SUCCESS = "RESEND_SUCCESS";
export const RESEND_FAILD = "RESEND_FAILD";

export const GET_MERCHANTS_SUCCESS = "GET_MERCHANTS_SUCCESS";
export const GET_MERCHANTS_FAILD = "GET_MERCHANTS_FAILD";
export const GET_MERCHANTS_LOADING = "GET_MERCHANTS_LOADING";
export const RESET_MERCHANT_LIST = "RESET_MERCHANT_LIST;";

export const MERCHANT_DATA_LOADING = "MERCHANT_DATA_LOADING";
export const MERCHANT_DATA_SUCCESS = "MERCHANT_DATA_SUCCESS";
export const MERCHANT_DATA_FAILD = "MERCHANT_DATA_FAILD";
export const MERCHANT_DATA_REMOVE = "MERCHANT_DATA_REMOVE";

export const MERCHANT_SUMMARY_LOADING = "MERCHANT_SUMMARY_LOADING";
export const MERCHANT_SUMMARY_SUCCESS = "MERCHANT_SUMMARY_SUCCESS";
export const MERCHANT_SUMMARY_FAILD = "MERCHANT_SUMMARY_FAILD";

export const RESET_LOADING = "RESET_LOADING";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const RESET_FAILD = "RESET_FAILD";

export const FORGOTPW_LOADING = "FORGOTPW_LOADING";
export const FORGOTPW_SUCCESS = "FORGOTPW_SUCCESS";
export const FORGOTPW_FAILD = "FORGOTPW_FAILD";
export const FORGOTP_REMOVE = "FORGOTP_REMOVE";

export const EDIT_MERCHANT_LOADING = "EDIT_MERCHANT_LOADING";
export const EDIT_MERCHANT_SUCCESS = "EDIT_MERCHANT_SUCCESS";
export const EDIT_MERCHANT_FAILD = "EDIT_MERCHANT_FAILD";
export const REMOVE_EDIT_MERCHANT = "REMOVE_EDIT_MERCHANT";

export const GET_TERMINALS_LOADING = "GET_TERMINALS_LOADING";
export const GET_TERMINALS_SUCCESS = "GET_TERMINALS_SUCCESS";
export const GET_TERMINALS_FAILD = "GET_TERMINALS_FAILD";
export const GET_TERMINALS_REMOVE = "GET_TERMINALS_REMOVE";

export const GET_RECONCILATION_HISTORY_LOADING =
  "GET_RECONCILATION_HISTORY_LOADING";
export const GET_RECONCILATION_HISTORY_SUCCESS =
  "GET_RECONCILATION_HISTORY_SUCCESS";
export const GET_RECONCILATION_HISTORY_FAILED =
  "GET_RECONCILATION_HISTORY_FAILED";

export const ADD_RECONCILE_LOADING = "ADD_RECONCILE_LOADING";
export const ADD_RECONCILE_SUCCESS = "ADD_RECONCILE_SUCCESS";
export const ADD_RECONCILE_FAILED = "ADD_RECONCILE_FAILED";

export const GET_FILTER_RECONCILIATION_LOADING =
  "GET_FILTER_RECONCILIATION_LOADING";
export const GET_FILTER_RECONCILIATION_SUCCESS =
  "GET_FILTER_RECONCILIATION_SUCCESS";
export const GET_FILTER_RECONCILIATION_FAILD =
  "GET_FILTER_RECONCILIATION_FAILD";
export const GET_FILTER_RECONCILIATION_RESET =
  "GET_FILTER_RECONCILIATION_RESET";

export const GET_OUTLETS_LOADING = "GET_OUTLETS_LOADING";
export const GET_OUTLETS_SUCCESS = "GET_OUTLETS_SUCCESS";
export const GET_OUTLETS_FAILD = "GET_OUTLETS_FAILD";

export const GET_TERMINAL_SUMMARY_LOADING = "GET_TERMINAL_SUMMARY_LOADING";
export const GET_TERMINAL_SUMMARY_SUCCESS = "GET_TERMINAL_SUMMARY_SUCCESS";
export const GET_TERMINAL_SUMMARY_FAILD = "GET_TERMINAL_SUMMARY_FAILD";

export const GET_TSN_TRANSACTIONS_LOADING = "GET_TSN_TRANSACTIONS_LOADING";
export const GET_TSN_TRANSACTIONS_SUCCESS = "GET_TSN_TRANSACTIONS_SUCCESS";
export const GET_TSN_TRANSACTIONS_FAILD = "GET_TSN_TRANSACTIONS_FAILD";
export const REMOVE_TSN_TRANSACTION = "REMOVE_TSN_TRANSACTION";

export const EDIT_USER_LOADING = "EDIT_USER_LOADING";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_FAILD = "EDIT_USER_FAILD";

export const GET_USERS_LOADING = "GET_USERS_LOADING";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILD = "GET_USERS_FAILD";
export const GET_USERS_REMOVE = "GET_USERS_REMOVE";

export const CREATE_USER_LOADING = "CREATE_USER_LOADING";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILD = "CREATE_USER_FAILD";

export const CREATE_OUTLET_LOADING = "CREATE_OUTLET_LOADING";
export const CREATE_OUTLET_SUCCESS = "CREATE_OUTLET_SUCCESS";
export const CREATE_OUTLET_FAILD = "CREATE_OUTLET_FAILD";

export const USER_SUMMARY_LOADING = "USER_SUMMARY_LOADING";
export const USER_SUMMARY_SUCCESS = "USER_SUMMARY_SUCCESS";
export const USER_SUMMARY_FAILD = "USER_SUMMARY_FAILD";

export const GET_USERS_TERMINALS_LOADING = "GET_USERS_TERMINALS_LOADING";
export const GET_USERS_TERMINALS_SUCCESS = "GET_USERS_TERMINALS_SUCCESS";
export const GET_USERS_TERMINALS_FAILD = "GET_USERS_TERMINALS_FAILD";

export const GET_USERS_TRANSACTIONS_LOADING = "GET_USERS_TRANSACTIONS_LOADING";
export const GET_USERS_TRANSACTIONS_SUCCESS = "GET_USERS_TRANSACTIONS_SUCCESS";
export const GET_USERS_TRANSACTIONS_FAILD = "GET_USERS_TRANSACTIONS_FAILD";
export const REMOVE_USERS_TRANSACTIONS = "REMOVE_USERS_TRANSACTIONS";

export const GET_USERS_BY_OUTLET_LOADING = "GET_USERS_BY_OUTLET_LOADING";
export const GET_USERS_BY_OUTLET_SUCCESS = "GET_USERS_BY_OUTLET_SUCCESS";
export const GET_USERS_BY_OUTLET_FAILD = "GET_USERS_BY_OUTLET_FAILD";

export const GET_OUTLET_SUMMARY_LOADING = "GET_OUTLET_SUMMARY_LOADING";
export const GET_OUTLET_SUMMARY_SUCCESS = "GET_OUTLET_SUMMARY_SUCCESS";
export const GET_OUTLET_SUMMARY_FAILD = "GET_OUTLET_SUMMARY_FAILD";

export const GET_OUTLETS_TERMINALS_LOADING = "GET_OUTLETS_TERMINALS_LOADING";
export const GET_OUTLETS_TERMINALS_SUCCESS = "GET_OUTLETS_TERMINALS_SUCCESS";
export const GET_OUTLETS_TERMINALS_FAILD = "GET_OUTLETS_TERMINALS_FAILD";

export const GET_OUTLET_DETAILS_LOADING = "GET_OUTLET_DETAILS_LOADING";
export const GET_OUTLET_DETAILS_SUCCESS = "GET_OUTLET_DETAILS_SUCCESS";
export const GET_OUTLET_DETAILS_FAILD = "GET_OUTLET_DETAILS_FAILD";

export const EDIT_OUTLET_LOADING = "EDIT_OUTLET_LOADING";
export const EDIT_OUTLET_SUCCESS = "EDIT_OUTLET_SUCCESS";
export const EDIT_OUTLET_FAILD = "EDIT_OUTLET_FAILD";

export const GET_CURRENCY_LOADING = "GET_CURRENCY_LOADING";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
export const GET_CURRENCY_FAILD = "GET_CURRENCY_FAILD";
export const GET_CURRENCY_REMOVE = "GET_CURRENCY_REMOVE";

export const ADD_CURRENCY_LOADING = "ADD_CURRENCY_LOADING";
export const ADD_CURRENCY_SUCCESS = "ADD_CURRENCY_SUCCESS";
export const ADD_CURRENCY_FAILD = "ADD_CURRENCY_FAILD";

export const GET_TRANSFER_CHARGE_LOADING = "GET_TRANSFER_CHARGE_LOADING";
export const GET_TRANSFER_CHARGE_SUCCESS = "GET_TRANSFER_CHARGE_SUCCESS";
export const GET_TRANSFER_CHARGE_FAILD = "GET_TRANSFER_CHARGE_FAILD";

export const ADD_TRANSFER_CHARGE_LOADING = "ADD_TRANSFER_CHARGE_LOADING";
export const ADD_TRANSFER_CHARGE_SUCCESS = "ADD_TRANSFER_CHARGE_SUCCESS";
export const ADD_TRANSFER_CHARGE_FAILD = "ADD_TRANSFER_CHARGE_FAILD";

export const GET_BusinessCategory_LOADING = "GET_BusinessCategory_LOADING";
export const GET_BusinessCategory_SUCCESS = "GET_BusinessCategory_SUCCESS";
export const GET_BusinessCategory_FAILD = "GET_BusinessCategory_FAILD";
export const GET_BusinessCategory_RESET = "GET_BusinessCategory_RESET";

export const GET_FilterSearch_LOADING = "GET_FilterSearch_LOADING";
export const GET_FilterSearch_SUCCESS = "GET_FilterSearch_SUCCESS";
export const GET_FilterSearch_FAILD = "GET_FilterSearch_FAILD";
export const Remove_FilterSearch = "Remove_FilterSearch";

export const GET_FILTER_TRANSACTION_LOADING = "GET_FILTER_TRANSACTION_LOADING";
export const GET_FILTER_TRANSACTION_SUCCESS = "GET_FILTER_TRANSACTION_SUCCESS";
export const GET_FILTER_TRANSACTION_FAILD = "GET_FILTER_TRANSACTION_FAILD";
export const GET_FILTER_TRANSACTION_RESET = "GET_FILTER_TRANSACTION_RESET";

export const GET_CountriesCities_LOADING = "GET_CountriesCities_LOADING";
export const GET_CountriesCities_SUCCESS = "GET_CountriesCities_SUCCESS";
export const GET_CountriesCities_FAILD = "GET_CountriesCities_FAILD";
export const GET_CountriesCities_RESET = "GET_CountriesCities_RESET";

export const Reset_PassWord_Success = "Reset_PassWord_Success";
export const Reset_PassWord_Failed = "Reset_PassWord_Failed";
export const Reset_PassWord_Loading = "Reset_PassWord_Loading";
export const Reset_password_Remove = "Reset_Password_Remove";

export const Add_Terminal_Success = "Add_Terminal_Success";
export const Add_Terminal_Failed = "Add_Terminal_Failed";
export const Add_Terminal_Loading = "Add_Terminal_Loading";
export const Add_Terminal_Reset = "Add_Terminal_Reset";

export const EDIT_Terminal_Success = "EDIT_Terminal_Success";
export const EDIT_Terminal_Failed = "EDIT_Terminal_Failed";
export const EDIT_Terminal_Loading = "EDIT_Terminal_Loading";
export const EDIT_Terminal_Reset = "EDIT_Terminal_Reset";

export const GET_MERCHANT_TRANSACTIONS_SUCCESS = "GET_MERCHANT_TRANSACTIONS";
export const GET_MERCHANT_TRANSACTIONS_FAILED =
  "GET_MERCHANT_TRANSACTIONS_FAILED";
export const GET_MERCHANT_TRANSACTIONS_LOADING =
  "GET_MERCHANT_TRANSACTIONS_LOADING";
export const REMOVE_MERCHANT_TRANSACTIONS = "REMOVE_MERCHANT_TRANSACTIONS";

export const DELETE_TERMINAL_SUCCESS = "DELETE_TERMINAL_SUCCESS";
export const DELETE_TERMINAL_FAILED = "DELETE_TERMINAL_FAILED";
export const DELETE_TERMINAL_LOADING = "DELETE_TERMINAL_LOADING";
export const DELETE_TERMINAL_REMOVE = "DELETE_TERMINAL_REMOVE";

export const GET_TODAY_BALANCE_SUCCESS = "GET_TODAY_BALANCE_SUCCESS";
export const GET_TODAY_BALANCE_FAILED = "GET_TODAY_BALANCE_FAILED";
export const GET_TODAY_BALANCE_LOADING = "GET_TODAY_BALANCE_LOADING";
export const REMOVE_TODAY_BALANCE = "REMOVE_TODAY_BALANCE";

export const GET_MERCHANT_TOP_USED_TERMINAL_SUCCESS =
  "GET_MERCHANT_TOP_USED_TERMINAL_SUCCESS";
export const GET_MERCHANT_TOP_USED_TERMINAL_FAILED =
  "GET_MERCHANT_TOP_USED_TERMINAL_FAILED";
export const GET_MERCHANT_TOP_USED_TERMINAL_LOADING =
  "GET_MERCHANT_TOP_USED_TERMINAL_LOADING";
export const REMOVE_MERCHANT_TOP_USED_TERMINAL =
  "REMOVE_MERCHANT_TOP_USED_TERMINAL";

export const GET_MERCHANT_LAST7_DAYS_TRANACTION_COUNT_SUCCESS =
  "GET_MERCHANT_LAST7_DAYS_TRANACTION_COUNT_SUCCESS";
export const GET_MERCHANT_LAST7_DAYS_TRANACTION_COUNT_FAILED =
  "GET_MERCHANT_LAST7_DAYS_TRANACTION_COUNT_FAILED";
export const GET_MERCHANT_LAST7_DAYS_TRANACTION_COUNT_LOADING =
  "GET_MERCHANT_LAST7_DAYS_TRANACTION_COUNT_LOADING";
export const REMOVE_MERCHANT_LAST7_DAYS_TRANACTION_COUNT =
  "REMOVE_MERCHANT_LAST7_DAYS_TRANACTION_COUNT";

export const GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_SUCCESS =
  "GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_SUCCESS";
export const GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_FAILED =
  "GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_FAILED";
export const GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_LOADING =
  "GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_LOADING";
export const REMOVE_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES =
  "REMOVE_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES";

export const GET_MERCHANT_USED_SCHEME_SUCCESS =
  "GET_MERCHANT_USED_SCHEME_SUCCESS";
export const GET_MERCHANT_USED_SCHEME_FAILED =
  "GET_MERCHANT_USED_SCHEME_FAILED";
export const GET_MERCHANT_USED_SCHEME_LOADING =
  "GET_MERCHANT_USED_SCHEME_LOADING";
export const REMOVE_MERCHANT_USED_SCHEME = "REMOVE_MERCHANT_USED_SCHEME";

export const GET_MERCHANT_TERMINALS_TRANSACTION_SUCCESS =
  "GET_MERCHANT_TERMINALS_TRANSACTION_SUCCESS";
export const GET_MERCHANT_TERMINALS_TRANSACTION_FAILED =
  "GET_MERCHANT_TERMINALS_TRANSACTION_FAILED";
export const GET_MERCHANT_TERMINALS_TRANSACTION_LOADING =
  "GET_MERCHANT_TERMINALS_TRANSACTION_LOADING";
export const REMOVE_MERCHANT_TERMINALS_TRANSACTION =
  "REMOVE_MERCHANT_TERMINALS_TRANSACTION";

export const GET_MERCHANT_OUTLET_TRANSACTION_SUCCESS =
  "GET_MERCHANT_OUTLET_TRANSACTION_SUCCESS";
export const GET_MERCHANT_OUTLET_TRANSACTION_FAILED =
  "GET_MERCHANT_OUTLET_TRANSACTION_FAILED";
export const GET_MERCHANT_OUTLET_TRANSACTION_LOADING =
  "GET_MERCHANT_OUTLET_TRANSACTION_LOADING";
export const REMOVE_MERCHANT_OUTLET_TRANSACTION =
  "REMOVE_MERCHANT_OUTLET_TRANSACTION";

export const GET_MERCHANT_AVAILABLE_TERMINAL_SUCCESS =
  "GET_MERCHANT_AVAILABLE_TERMINAL_SUCCESS";
export const GET_MERCHANT_AVAILABLE_TERMINAL_FAILED =
  "GET_MERCHANT_AVAILABLE_TERMINAL_FAILED";
export const GET_MERCHANT_AVAILABLE_TERMINAL_LOADING =
  "GET_MERCHANT_AVAILABLE_TERMINAL_LOADING";
export const REMOVE_MERCHANT_AVAILABLE_TERMINAL =
  "REMOVE_MERCHANT_AVAILABLE_TERMINAL";

export const EDIT_MERCHANT_AVAILABLE_TERMINAL_SUCCESS =
  "EDIT_MERCHANT_AVAILABLE_TERMINAL_SUCCESS";
export const EDIT_MERCHANT_AVAILABLE_TERMINAL_FAILED =
  "EDIT_MERCHANT_AVAILABLE_TERMINAL_FAILED";
export const EDIT_MERCHANT_AVAILABLE_TERMINAL_LOADING =
  "EDIT_MERCHANT_AVAILABLE_TERMINAL_LOADING";

export const ADD_TERMINAL_RETAILER_DATA_SUCCESS =
  "ADD_TERMINAL_RETAILER_DATA_SUCCESS";
export const ADD_TERMINAL_RETAILER_DATA_FAILED =
  "ADD_TERMINAL_RETAILER_DATA_FAILED";
export const ADD_TERMINAL_RETAILER_DATA_LOADING =
  "ADD_TERMINAL_RTAILER_DATA_LOADING";

export const ADD_TERMINAL_TMS_SCHEME_SUCCESS =
  "ADD_TERMINAL_TMS_SCHEME_SUCCESS";
export const ADD_TERMINAL_TMS_SCHEME_FAILED = "ADD_TERMINAL_TMS_SCHEME_FAILED";
export const ADD_TERMINAL_TMS_SCHEME_LOADING =
  "ADD_TERMINAL_TMS_SCHEME_LOADING";

export const ADD_CREATE_INVOICE_SUCCESS = "ADD_CREATE_INVOICE_SUCCESS";
export const ADD_CREATE_INVOICE_FAILED = "ADD_CREATE_INVOICE_FAILED";
export const ADD_CREATE_INVOICE_LOADING = "ADD_CREATE_INVOICE_LOADING";
export const REMOVE_CREATE_INVOICE = "REMOVE_CREATE_INVOICE";

export const GET_MERCHANT_INVOICE_LIST_SUCCESS =
  "GET_MERCHANT_INVOICE_LIST_SUCCESS";
export const GET_MERCHANT_INVOICE_LIST_FAILED =
  "GET_MERCHANT_INVOICE_LIST_FAILED";
export const GET_MERCHANT_INVOICE_LIST_LOADING =
  "GET_MERCHANT_INVOICE_LIST_LOADING";
export const REMOVE_MERCHANT_INVOICE_LIST = "REMOVE_MERCHANT_INVOICE_LIST";

export const GET_MERCHANT_INVOICE_SUCCESS = "GET_MERCHANT_INVOICE_SUCCESS";
export const GET_MERCHANT_INVOICE_FAILED = "GET_MERCHANT_INVOICE_FAILED";
export const GET_MERCHANT_INVOICE_LOADING = "GET_MERCHANT_INVOICE_LOADING";
export const REMOVE_MERCHANT_INVOICE = "REMOVE_MERCHANT_INVOICE";

export const GET_FILTER_INVOICES_LOADING = "GET_FILTER_INVOICES_LOADING";
export const GET_FILTER_INVOICES_SUCCESS = "GET_FILTER_INVOICES_SUCCESS";
export const GET_FILTER_INVOICES_FAILD = "GET_FILTER_INVOICES_FAILD";
export const GET_FILTER_INVOICES_RESET = "GET_FILTER_INVOICES_RESET";

export const GET_MERCHANT_PAYMENT_CONFIG_SUCCESS =
  "GET_MERCHANT_PAYMENT_CONFIG_SUCCESS";
export const GET_MERCHANT_PAYMENT_CONFIG_FAILED =
  "GET_MERCHANT_PAYMENT_CONFIG_FAILED";
export const GET_MERCHANT_PAYMENT_CONFIG_LOADING =
  "GET_MERCHANT_PAYMENT_CONFIG_LOADING";
export const REMOVE_MERCHANT_PAYMENT_CONFIG = "REMOVE_MERCHANT_PAYMENT_CONFIG";

export const ADD_MERCHANT_PAYMENT_CONFIG_SUCCESS =
  "ADD_MERCHANT_PAYMENT_CONFIG_SUCCESS";
export const ADD_MERCHANT_PAYMENT_CONFIG_FAILED =
  "ADD_MERCHANT_PAYMENT_CONFIG_FAILED";
export const ADD_MERCHANT_PAYMENT_CONFIG_LOADING =
  "ADD_MERCHANT_PAYMENT_CONFIG_LOADING";
export const REMOVE_ADD_MERCHANT_PAYMENT_CONFIG =
  "REMOVE_ADD_MERCHANT_PAYMENT_CONFIG";

export const GET_INVOICE_PAYMENT_URL_SUCCESS =
  "GET_INVOICE_PAYMENT_URL_SUCCESS";
export const GET_INVOICE_PAYMENT_URL_FAILED = "GET_INVOICE_PAYMENT_URL_FAILED";
export const GET_INVOICE_PAYMENT_URL_LOADING =
  "GET_INVOICE_PAYMENT_URL_LOADING";
export const REMOVE_INVOICE_PAYMENT_URL = "REMOVE_MERCHANT_PAYMENT_URL";

export const EDIT_INVOICE_STATUS_Success = "EDIT_INVOICE_STATUS_Success";
export const EDIT_INVOICE_STATUS_Failed = "EDIT_INVOICE_STATUS_Failed";
export const EDIT_INVOICE_STATUS_Loading = "EDIT_INVOICE_STATUS_Loading";
export const EDIT_INVOICE_STATUS_Reset = "EDIT_INVOICE_STATUS_Reset";

export const DOWNLOAD_INVOICE_Success = "DOWNLOAD_INVOICE_Success";
export const DOWNLOAD_INVOICE_Failed = "DOWNLOAD_INVOICE_Failed";
export const DOWNLOAD_INVOICE_Loading = "DOWNLOAD_INVOICE_Loading";
export const DOWNLOAD_INVOICE_Reset = "DOWNLOAD_INVOICE_Reset";

export const SEND_INVOICE_NOTIIFICATION_Success =
  "SEND_INVOICE_NOTIIFICATION_Success";
export const SEND_INVOICE_NOTIIFICATION_Failed =
  "SEND_INVOICE_NOTIIFICATION_Failed";
export const SEND_INVOICE_NOTIIFICATION_Loading =
  "SEND_INVOICE_NOTIIFICATION_Loading";
export const SEND_INVOICE_NOTIIFICATION_Reset =
  "SEND_INVOICE_NOTIIFICATION_Reset";

/* export const DELETE_TERMINAL_SUCCESS = "DELETE_TERMINAL_SUCCESS" ; 
export const DELETE_TERMINAL_FAILED ="DELETE_TERMINAL_FAILED" ; 
export const DELETE_TERMINAL_LOADING ="DELETE_TERMINAL_LOADING" ;  */

// payment gateway transactions
export const GET_TRANSACTION_DATA_LOADING = " GET_TRANSACTION_DATA_LOADING";
export const GET_TRANSACTION_DATA_SUCCESS = "GET_TRANSACTION_DATA_SUCCESS";
export const GET_TRANSACTION_DATA_FAILED = "GET_TRANSACTION_DATA_FAILED";
export const GET_TRANSACTION_DATA_REMOVE = "GET_TRANSACTION_DATA_REMOVE";

// apple transactions
export const GET_APPLE_TRANSACTION_DATA_LOADING =
  " GET_APPLE_TRANSACTION_DATA_LOADING";
export const GET_APPLE_TRANSACTION_DATA_SUCCESS =
  "GET_APPLE_TRANSACTION_DATA_SUCCESS";
export const GET_APPLE_TRANSACTION_DATA_FAILED =
  "GET_APPLE_TRANSACTION_DATA_FAILED";
export const GET_APPLE_TRANSACTION_DATA_REMOVE =
  "GET_APPLE_TRANSACTION_DATA_REMOVE";

//payement gateway dashboard data, summary
export const FETCH_DASHBOARD_DATA_REQUEST = "FETCH_DASHBOARD_DATA_REQUEST";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";
export const FETCH_DASHBOARD_DATA_REMOVE = "FETCH_DASHBOARD_DATA_REMOVE";

//payment gateway dashboard , highlights chart
export const FETCH_TRANSACTIONS_HIGHLIGHTS_REQUEST =
  "FETCH_TRANSACTIONS_REQUEST";
export const FETCH_TRANSACTIONS_HIGHLIGHTS_SUCCESS =
  "FETCH_TRANSACTIONS_SUCCESS";
export const FETCH_TRANSACTIONS_HIGHLIGHTS_FAILURE =
  "FETCH_TRANSACTIONS_FAILURE";
export const FETCH_TRANSACTIONS_HIGHLIGHTS_REMOVE = "FETCH_TRANSACTIONS_REMOVE";

//payment gateway dashboard, payement methods, visa, mastercards etc
export const FETCH_PAYEMENT_METHODS_REQUEST = "FETCH_PAYMENT_METHODS_REQUEST";
export const FETCH_PAYEMENT_METHODS_SUCCESS = "FETCH_PAYMENT_METHODS_SUCCESS";
export const FETCH_PAYEMENT_METHODS_FAILURE = "FETCH_PAYMENT_METHODS_FAILURE";
export const FETCH_PAYEMENT_METHODS_REMOVE = "FETCH_PAYMENT_METHODS_REMOVE";

//payment gateway dashboard, geo payment map
export const FETCH_GEO_PAYEMENT_REQUEST = "FETCH_GEO_PAYMENT_REQUEST";
export const FETCH_GEO_PAYEMENT_SUCCESS = "FETCH_GEO_PAYMENT_SUCCESS";
export const FETCH_GEO_PAYEMENT_FAILURE = "FETCH_GEO_PAYMENT_FAILURE";
export const FETCH_GEO_PAYEMENT_REMOVE = "FETCH_GEO_PAYMENT_REMOVE";

//payment gateway chart, bar chart
export const FETCH_PAYEMENT_CHART_REQUEST = "FETCH_PAYMENT_CHART_REQUEST";
export const FETCH_PAYEMENT_CHART_SUCCESS = "FETCH_PAYMENT_CHART_SUCCESS";
export const FETCH_PAYEMENT_CHART_FAILURE = "FETCH_PAYMENT_CHART_FAILURE";
export const FETCH_PAYEMENT_CHART_REMOVE = "FETCH_PAYMENT_CHART_REMOVE";

//apple pay merchant config
export const ADD_APPLEPAY_LOADING = "ADD_APPLEPAY_LOADING";
export const ADD_APPLEPAY_SUCCESS = "ADD_APPLEPAY_SUCCESS";
export const ADD_APPLEPAY_FAILED = "ADD_APPLEPAY_FAILED";

//add card payment merchant config
export const ADD_CARDCONFIG_LOADING = "ADD_CARDCONFIG_LOADING";
export const ADD_CARDCONFIG_SUCCESS = "ADD_CARDCONFIG_SUCCESS";
export const ADD_CARDCONFIG_FAILED = "ADD_CARDCONFIG_FAILED";

//update card payment merchant config
export const PUT_CARDCONFIG_LOADING = "PUT_CARDCONFIG_LOADING";
export const PUT_CARDCONFIG_SUCCESS = "PUT_CARDCONFIG_SUCCESS";
export const PUT_CARDCONFIG_FAILED = "PUT_CARDCONFIG_FAILED";

//update urpay payment merchant config
export const PUT_URPAYCONFIG_LOADING = "PUT_URPAYCONFIG_LOADING";
export const PUT_URPAYCONFIG_SUCCESS = "PUT_URPAYCONFIG_SUCCESS";
export const PUT_URPAYCONFIG_FAILED = "PUT_URPAYCONFIG_FAILED";

//update apple payment merchant config
export const PUT_APPLECONFIG_LOADING = "PUT_APPLECONFIG_LOADING";
export const PUT_APPLECONFIG_SUCCESS = "PUT_APPLECONFIG_SUCCESS";
export const PUT_APPLECONFIG_FAILED = "PUT_APPLECONFIG_FAILED";
export const PUT_APPLECONFIG_REMOVE = "PUT_APPLECONFIG_REMOVE";



//find payment merchant config
export const GET_PAYMENTCONFIG_LOADING = "GET_PAYMENTCONFIG_LOADING";
export const GET_PAYMENTCONFIG_SUCCESS = "GET_PAYMENTCONFIG_SUCCESS";
export const GET_PAYMENTCONFIG_FAILED = "GET_PAYMENTCONFIG_FAILED";
export const GET_PAYMENTCONFIG_REMOVE = "GET_PAYMENTCONFIG_REMOVE";

//find urpay payment merchant config
export const GET_URPAYCONFIG_LOADING = "GET_URPAYCONFIG_LOADING";
export const GET_URPAYCONFIG_SUCCESS = "GET_URPAYCONFIG_SUCCESS";
export const GET_URPAYCONFIG_FAILED = "GET_URPAYCONFIG_FAILED";

//find apple payment merchant config
export const GET_APPLECONFIG_LOADING = "GET_APPLECONFIG_LOADING";
export const GET_APPLECONFIG_SUCCESS = "GET_APPLECONFIG_SUCCESS";
export const GET_APPLECONFIG_FAILED = "GET_APPLECONFIG_FAILED";
export const GET_APPLECONFIG_REMOVE =" GET_APPLECONFIG_REMOVE";

//add urpay merchant config
export const ADD_URPAYCONFIG_LOADING = "ADD_URPAYCONFIG_LOADING";
export const ADD_URPAYCONFIG_SUCCESS = "ADD_URPAYCONFIG_SUCCESS";
export const ADD_URPAYCONFIG_FAILED = "ADD_URPAYCONFIG_FAILED";

//MANAFITH
export const ADD_MANAFITH_LOADING = "ADD_MANAFITH_LOADING";
export const ADD_MANAFITH_SUCCESS = "ADD_MANAFITH_SUCCESS";
export const ADD_MANAFITH_FAILED = "ADD_MANAFITH_FAILED";
export const ADD_MANAFITH_REMOVE = "ADD_MANAFITH_REMOVE";

//Tamara
export const ADD_TAMARAH_LOADING = "ADD_TAMARAH_LOADING";
export const ADD_TAMARAH_SUCCESS = "ADD_TAMARAH_SUCCESS";
export const ADD_TAMARAH_FAILED = "ADD_TAMARAH_FAILED";
export const ADD_TAMARAH_REMOVE = "ADD_TAMARAH_REMOVE";
//Tabby
export const ADD_TABBY_LOADING = "ADD_TABBY_LOADING";
export const ADD_TABBY_SUCCESS = "ADD_TABBY_SUCCESS";
export const ADD_TABBY_FAILED = "ADD_TABBY_FAILED";
export const ADD_TABBY_REMOVE = "ADD_TABBY_REMOVE";

//SADAD
export const ADD_SADAD_LOADING = "ADD_SADAD_LOADING";
export const ADD_SADAD_SUCCESS = "ADD_SADAD_SUCCESS";
export const ADD_SADAD_FAILED = "ADD_SADAD_FAILED";
export const ADD_SADAD_REMOVE = "ADD_SADAD_REMOVE";

//ClickToPay
export const ADD_CLICKTOPAY_LOADING = "ADD_CLICKTOPAY_LOADING";
export const ADD_CLICKTOPAY_SUCCESS = "ADD_CLICKTOPAY_SUCCESS";
export const ADD_CLICKTOPAY_FAILED = "ADD_CLICKTOPAY_FAILED";
export const ADD_CLICKTOPAY_REMOVE = "ADD_CLICKTOPAY_REMOVE";

//add merchant onboarding
export const ADD_NEWMERCHANT_LOADING = "ADD_NEWMERCHANT_LOADING";
export const ADD_NEWMERCHANT_SUCCESS = "ADD_NEWMERCHANT_SUCCESS";
export const ADD_NEWMERCHANT_FAILED = "ADD_NEWMERCHANT_FAILED";
export const ADD_NEWMERCHANT_REMOVE = "ADD_NEWMERCHANT_REMOVE";

//
export const GET_ONBOADINGFILES_LOADING = "GET_ONBOADINGFILES_LOADING";
export const GET_ONBOADINGFILES_SUCCESS = "GET_ONBOADINGFILES_SUCCESS";
export const GET_ONBOADINGFILES_FAILED = "GET_ONBOADINGFILES_FAILED";
export const GET_ONBOADINGFILES_REMOVE = "GET_ONBOADINGFILES_REMOVE";

//add new Product
export const ADD_NEWPRODUCT_LOADING = "ADD_NEWPRODUCT_LOADING";
export const ADD_NEWPRODUCT_SUCCESS = "ADD_NEWPRODUCT_SUCCESS";
export const ADD_NEWPRODUCT_FAILED = "ADD_NEWPRODUCT_FAILED";

//get product list
export const GET_PRODUCT_LOADING = "GET_PRODUCT_LOADING";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILED = "GET_PRODUCT_FAILED";

//edit Product
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILED = "EDIT_PRODUCT_FAILED";
export const EDIT_PRODUCT_LOADING = "EDIT_PRODUCT_LOADING";

//delete Product
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILED = "DELETE_PRODUCT_FAILED";
export const DELETE_PRODUCT_LOADING = "DELETE_PRODUCT_LOADING";

//delete Customer
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAILED = "DELETE_CUSTOMER_FAILED";
export const DELETE_CUSTOMER_LOADING = "DELETE_CUSTOMER_LOADING";

//add new Customer
export const ADD_NEWCUSTOMER_LOADING = "ADD_NEWCUSTOMER_LOADING";
export const ADD_NEWCUSTOMER_SUCCESS = "ADD_NEWCUSTOMER_SUCCESS";
export const ADD_NEWCUSTOMER_FAILED = "ADD_NEWCUSTOMER_FAILED";

//get customers list
export const GET_CUSTOMERS_LOADING = "GET_CUSTOMERS_LOADING";
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMERS_FAILED = "GET_CUSTOMERS_FAILED";
//verify merchant IBAN
export const VERIFY_MERCHANT_IBAN_LOADING = "VERIFY_MERCHANT_IBAN_LOADING";
export const VERIFY_MERCHANT_IBAN_SUCCESS = "VERIFY_MERCHANT_IBAN_SUCCESS";
export const VERIFY_MERCHANT_IBAN_FAILED = "VERIFY_MERCHANT_IBAN_FAILED";
export const VERIFY_MERCHANT_IBAN_REMOVE = "VERIFY_MERCHANT_IBAN_REMOVE";

export const PRODUCT_LOADING = "PRODUCT_LOADING";
export const PRODUCT_SUCCESS = "PRODUCT_SUCCESS";
export const PRODUCT_FAILED = "PRODUCT_FAILED";
export const PRODUCT_REMOVE = "PRODUCT_REMOVE";

export const CUSTOMER_LOADING = "CUSTOMER_LOADING";
export const CUSTOMER_SUCCESS = "CUSTOMER_SUCCESS";
export const CUSTOMER_FAILED = "CUSTOMER_FAILED";
export const CUSTOMER_REMOVE = "CUSTOMER_REMOVE";

//get terminals list-filter
export const GET_TERMINALSLIST_LOADING = "GET_TERMINALSLIST_LOADING";
export const GET_TERMINALSLIST_FAILED = "GET_TERMINALSLIST_FAILED";
export const GET_TERMINALSLIST_SUCCESS = "GET_TERMINALSLIST_SUCCESS";

//edit customer
export const EDIT_CUSTOMERS_LOADING = "EDIT_CUSTOMERS_LOADING";
export const EDIT_CUSTOMERS_SUCCESS = "EDIT_CUSTOMERS_SUCCESS";
export const EDIT_CUSTOMERS_FAILED = "EDIT_CUSTOMERS_FAILED";

//delete Merchant
export const DELETE_MERCHANT_SUCCESS = "DELETE_MERCHANT_SUCCESS";
export const DELETE_MERCHANT_FAILED = "DELETE_MERCHANT_FAILED";
export const DELETE_MERCHANT_LOADING = "DELETE_MERCHANT_LOADING";
export const DELETE_MERCHANT_REMOVE = "DELETE_MERCHANT_REMOVE";

//get countries list
export const GET_ALLCOUNTRY_LOADING = "GET_ALLCOUNTRY_LOADING";
export const GET_ALLCOUNTRY_SUCCESS = "GET_ALLCOUNTRY_SUCCESS";
export const GET_ALLCOUNTRY_FAILED = "GET_ALLCOUNTRY_FAILED";

//add countries list
export const ADD_COUNTRY_LOADING = "ADD_COUNTRY_LOADING";
export const ADD_COUNTRY_SUCCESS = "ADD_COUNTRY_SUCCESS";
export const ADD_COUNTRY_FAILED = "ADD_COUNTRY_FAILED";

//delete countries list
export const DELETE_COUNTRY_LOADING = "DELETE_COUNTRY_LOADING";
export const DELETE_COUNTRY_SUCCESS = "DELETE_COUNTRY_SUCCESS";
export const DELETE_COUNTRY_FAILED = "DELETE_COUNTRY_FAILED";

//get countries list
export const GET_CITY_LOADING = "GET_CITYY_LOADING";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_FAILED = "GET_CITY_FAILED";

//edit country
export const EDIT_CITY_LOADING = "EDIT_CITY_LOADING";
export const EDIT_CITY_SUCCESS = "EDIT_CITY_SUCCESS";
export const EDIT_CITY_FAILED = "EDIT_CITY_FAILED";

//add countries list
export const ADD_CITY_LOADING = "ADD_CITY_LOADING";
export const ADD_CITY_SUCCESS = "ADD_CITY_SUCCESS";
export const ADD_CITY_FAILED = "ADD_CITY_FAILED";

//add countries list
export const DELETE_CITY_LOADING = "DELETE_CITY_LOADING";
export const DELETE_CITY_SUCCESS = "DELETE_CITY_SUCCESS";
export const DELETE_CITY_FAILED = "DELETE_CITY_FAILED";

//edit country
export const EDIT_COUNTRY_LOADING = "EDIT_COUNTRY_LOADING";
export const EDIT_COUNTRY_SUCCESS = "EDIT_COUNTRY_SUCCESS";
export const EDIT_COUNTRY_FAILED = "EDIT_COUNTRY_FAILED";

//get countries list
export const GET_ALLCURRENCY_LOADING = "GET_ALLCURRENCY_LOADING";
export const GET_ALLCURRENCY_SUCCESS = "GET_ALLCURRENCY_SUCCESS";
export const GET_ALLCURRENCY_FAILED = "GET_ALLCURRENCY_FAILED";

export const GET_ALL_TRANSFER_CHARGE_LOADING =
  "GET_ALL_TRANSFER_CHARGE_LOADING";
export const GET_ALL_TRANSFER_CHARGE_SUCCESS =
  "GET_ALL_TRANSFER_CHARGE_SUCCESS";
export const GET_ALL_TRANSFER_CHARGE_FAILED = "GET_ALL_TRANSFER_CHARGE_FAILED";
export const CLEAR_ALL_TRANSFER_CHARGE = "CLEAR_ALL_TRANSFER_CHARGE";

//add tms
export const ADD_NEWTMS_LOADING = "ADD_NEWTMS_LOADING";
export const ADD_NEWTMS_SUCCESS = "ADD_NEWTMS_SUCCESS";
export const ADD_NEWTMS_FAILED = "ADD_NEWTMS_FAILED";

//get all tms
export const GET_ALLTMS_LOADING = "GET_ALLTMS_LOADING";
export const GET_ALLTMS_SUCCESS = "GET_ALLTMS_SUCCESS";
export const GET_ALLTMS_FAILED = "GET_ALLTMS_FAILED";
export const GET_ALLTMS_REMOVE = "GET_ALLTMS_REMOVE";

export const ADD_BUSINESSCATEGORY_LOADING = "ADD_BUSINESSCATEGORY_LOADING";
export const ADD_BUSINESSCATEGORY_SUCCESS = "ADD_BUSINESSCATEGORY_SUCCESS";
export const ADD_BUSINESSCATEGORY_FAILED = "ADD_BUSINESSCATEGORY_FAILED";

export const UPDATE_BUSINESSCATEGORY_LOADING =
  "UPDATE_BUSINESSCATEGORY_LOADING";
export const UPDATE_BUSINESSCATEGORY_SUCCESS =
  "UPDATE_BUSINESSCATEGORY_SUCCESS";
export const UPDATE_BUSINESSCATEGORY_FAILED = "UPDATE_BUSINESSCATEGORY_FAILED";

export const GET_ALLBUSINESSCATEGORY_LOADING =
  "GET_ALLBUSINESSCATEGORY_LOADING";
export const GET_ALLBUSINESSCATEGORY_SUCCESS =
  "GET_ALLBUSINESSCATEGORY_SUCCESS";
export const GET_ALLBUSINESSCATEGORY_FAILED = "GET_ALLBUSINESSCATEGORY_FAILED";

export const ACTIVATE_BUSINESSCATEGORY_LOADING =
  "ACTIVATE_BUSINESSCATEGORY_LOADING";
export const ACTIVATE_BUSINESSCATEGORY_SUCCESS =
  "ACTIVATE_BUSINESSCATEGORY_SUCCESS";
export const ACTIVATE_BUSINESSCATEGORY_FAILED =
  "ACTIVATE_BUSINESSCATEGORY_FAILED";

export const DEACTIVATE_BUSINESSCATEGORY_LOADING =
  "DEACTIVATE_BUSINESSCATEGORY_LOADING";
export const DEACTIVATE_BUSINESSCATEGORY_SUCCESS =
  "DEACTIVATE_BUSINESSCATEGORY_SUCCESS";
export const DEACTIVATE_BUSINESSCATEGORY_FAILED =
  "DEACTIVATE_BUSINESSCATEGORY_FAILED";

export const ACTIVATE_TMS_LOADING = "ACTIVATE_TMS_LOADING";
export const ACTIVATE_TMS_SUCCESS = "ACTIVATE_TMS_SUCCESS";
export const ACTIVATE_TMS_FAILED = "ACTIVATE_TMS_FAILED";

export const DEACTIVATE_TMS_LOADING = "DEACTIVATE_TMS_LOADING";
export const DEACTIVATE_TMS_SUCCESS = "DEACTIVATE_TMS_SUCCESS";
export const DEACTIVATE_TMS_FAILED = "DEACTIVATE_TMS_FAILED";

export const EDIT_CURRENCY_LOADING = "EDIT_CURRENCY_LOADING";
export const EDIT_CURRENCY_SUCCESS = "EDIT_CURRENCY_SUCCESS";
export const EDIT_CURRENCY_FAILED = "EDIT_CURRENCY_FAILED";

export const DELETE_CURRENCY_LOADING = "DELETE_CURRENCY_LOADING";
export const DELETE_CURRENCY_SUCCESS = "DELETE_CURRENCY_SUCCESS";
export const DELETE_CURRENCY_FAILED = "DELETE_CURRENCY_FAILED";

export const EDIT_TRANSFER_CHARGE_LOADING = "EDIT_TRANSFER_CHARGE_LOADING";
export const EDIT_TRANSFER_CHARGE_SUCCESS = "EDIT_TRANSFER_CHARGE_SUCCESS";
export const EDIT_TRANSFER_CHARGE_FAILED = "EDIT_TRANSFER_CHARGE_FAILED";

export const DELETE_TRANSFER_CHARGE_LOADING = "DELETE_TRANSFER_CHARGE_LOADING";
export const DELETE_TRANSFER_CHARGE_SUCCESS = "DELETE_TRANSFER_CHARGE_SUCCESS";
export const DELETE_TRANSFER_CHARGE_FAILED = "DELETE_TRANSFER_CHARGE_FAILED";

export const GET_ALLRETAILER_LOADING = "GET_ALLRETAILER_LOADING";
export const GET_ALLRETAILER_SUCCESS = "GET_ALLRETAILER_SUCCESS";
export const GET_ALLRETAILER_FAILED = "GET_ALLRETAILER_FAILED";
export const GET_ALLRETAILER_REMOVE = "GET_ALLRETAILER_REMOVE";

export const EDIT_RETAILER_LOADING = "EDIT_RETAILER_LOADING";
export const EDIT_RETAILER_SUCCESS = "EDIT_RETAILER_SUCCESS";
export const EDIT_RETAILER_FAILED = "EDIT_RETAILER_FAILED";

export const ADD_RETAILER_LOADING = "ADD_RETAILER_LOADING";
export const ADD_RETAILER_SUCCESS = "ADD_RETAILER_SUCCESS";
export const ADD_RETAILER_FAILED = "ADD_RETAILER_FAILED";

export const PARTNER_LOADING = "PARTNER_LOADING";
export const PARTNER_SUCCESS = "PARTNER_SUCCESS";
export const PARTNER_FAILED = "PARTNER_FAILED";
export const PARTNER_REMOVE = "PARTNER_REMOVE";

export const GET_PARTNER_LOADING = "GET_PARTNER_LOADING";
export const GET_PARTNER_SUCCESS = "GET_PARTNER_SUCCESS";
export const GET_PARTNER_FAILED = "GET_PARTNER_FAILED";
export const GET_PARTNER_REMOVE = "GET_PARTNER_REMOVE";

export const GET_AUDITLOGS_LOADING = "GET_AUDITLOGS_LOADING";
export const GET_AUDITLOGS_SUCCESS = "GET_AUDITLOGS_SUCCESS";
export const GET_AUDITLOGS_FAILED = "GET_AUDITLOGS_FAILED";

export const GET_ALLPAYMENTGY_LOADING = "GET_ALLPAYMENTGY_LOADING";
export const GET_ALLPAYMENTGY_SUCCESS = "GET_ALLPAYMENTGY_SUCCESS";
export const GET_ALLPAYMENTGY_FAILED = "GET_ALLPAYMENTGY_FAILED";

export const GET_VERSIONDETAILS_LOADING = "GET_VERSIONDETAILS_LOADING";
export const GET_VERSIONDETAILS_SUCCESS = "GET_VERSIONDETAILS_SUCCESS";
export const GET_VERSIONDETAILS_FAILED = "GET_VERSIONDETAILS_FAILED";

export const ADD_NEWVERSION_LOADING = "ADD_NEWVERSIONY_LOADING";
export const ADD_NEWVERSION_SUCCESS = "ADD_NEWVERSION_SUCCESS";
export const ADD_NEWVERSION_FAILED = "ADD_NEWVERSION_FAILED";
export const ADD_NEWVERSION_REMOVE = "ADD_NEWVERSION_REMOVE";

export const GET_PARTNERTHEME_LOADING = "GET_PARTNERTHEME_LOADING";
export const GET_PARTNERTHEME_SUCCESS = "GET_PARTNERTHEME_SUCCESS";
export const GET_PARTNERTHEME_FAILED = "GET_PARTNERTHEME_FAILED";
export const GET_PARTNERTHEME_REMOVE = "GET_PARTNERTHEME_REMOVE";

export const GET_TRX_REQ_LOADING = "GET_TRX_REQ_LOADING";
export const GET_TRX_REQ_SUCCESS = "GET_TRX_REQ_SUCCESS";
export const GET_TRX_REQ_FAILED = "GET_TRX_REQ_FAILED";
export const GET_TRX_REQ_REMOVE = "GET_TRX_REQ_REMOVE";

export const GET_TRX_RES_LOADING = "GET_TRX_RES_LOADING";
export const GET_TRX_RES_SUCCESS = "GET_TRX_RES_SUCCESS";
export const GET_TRX_RES_FAILED = "GET_TRX_RES_FAILED";
export const GET_TRX_RES_REMOVE = "GET_TRX_RES_REMOVE";

export const PAYOUT_MERCHANT_LOADING = "PAYOUT_MERCHANT_LOADING";
export const PAYOUT_MERCHANT_SUCCESS = "PAYOUT_MERCHANT_SUCCESS";
export const PAYOUT_MERCHANT_FAILED = "PAYOUT_MERCHANT_FAILED";
export const PAYOUT_MERCHANT_REMOVE = "PAYOUT_MERCHANT_REMOVE";
export const PAYOUT_GET_MERCHANTS = "PAYOUT_GET_MERCHANTS";

// bank accounts  reducers
export const GET_BANK_ACCOUNTS_LOADING = "GET_BANK_ACCOUNTS_LOADING";
export const GET_BANK_ACCOUNTS_SUCCESS = "GET_BANK_ACCOUNTS_SUCCESS";
export const GET_BANK_ACCOUNTS_FAILED = "GET_BANK_ACCOUNTS_FAILED";
export const CLEAR_BANK_ACCOUNTS = "CLEAR_BANK_ACCOUNTS";

//payout configuration reducers
export const PAYOUT_CONFIGURATION_LOADING = "PAYOUT_CONFIGURATION_LOADING";
export const PAYOUT_CONFIGURATION_SUCCESS = "PAYOUT_CONFIGURATION_SUCCESS";
export const PAYOUT_CONFIGURATION_FAILED = "PAYOUT_CONFIGURATION_FAILED";
export const CLEAR_PAYOUT_CONFIGURATION = "CLEAR_PAYOUT_CONFIGURATION";

// fee profile reducers
export const GET_FEE_PROFILE_LOADING = "GET_FEE_PROFILE_LOADING";
export const GET_FEE_PROFILE_SUCCESS = "GET_FEE_PROFILE_SUCCESS";
export const GET_FEE_PROFILE_FAILED = "GET_FEE_PROFILE_FAILED";
export const CLEAR_FEE_PROFILE = "CLEAR_FEE_PROFILE";

export const GET_ASSOCIATED_BANK_LOADING = "GET_ASSOCIATED_BANK_LOADING";
export const GET_ASSOCIATED_BANK_SUCCESS = "GET_ASSOCIATED_BANK_SUCCESS";
export const GET_ASSOCIATED_BANK_FAILED = "GET_ASSOCIATED_BANK_FAILED";

export const EDIT_FEE_PROFILE_LOADING = "EDIT_FEE_PROFILE_LOADING";
export const EDIT_FEE_PROFILE_SUCCESS = "EDIT_FEE_PROFILE_SUCCESS";
export const EDIT_FEE_PROFILE_FAILED = "EDIT_FEE_PROFILE_FAILED";

export const ADD_FEE_PROFILE_LOADING = "ADD_FEE_PROFILE_LOADING";
export const ADD_FEE_PROFILE_SUCCESS = "ADD_FEE_PROFILE_SUCCESS";
export const ADD_FEE_PROFILE_FAILED = "ADD_FEE_PROFILE_FAILED";

export const CHANGE_FEE_PROFILE_STATUS_LOADING =
  "CHANGE_FEE_PROFILE_STATUS_LOADING";
export const CHANGE_FEE_PROFILE_STATUS_SUCCESS =
  "CHANGE_FEE_PROFILE_STATUS_SUCCESS";
export const CHANGE_FEE_PROFILE_STATUS_FAILED =
  "CHANGE_FEE_PROFILE_STATUS_FAILED";

export const DELETE_FEE_PROFILE_LOADING = "DELETE_FEE_PROFILE_LOADING";
export const DELETE_FEE_PROFILE_SUCCESS = "DELETE_FEE_PROFILE_SUCCESS";
export const DELETE_FEE_PROFILE_FAILED = "DELETE_FEE_PROFILE_FAILED";

// fee plan reducers
export const FEE_PLAN_LOADING = "FEE_PLAN_LOADING";
export const FEE_PLAN_SUCCESS = "FEE_PLAN_SUCCESS";
export const FEE_PLAN_FAILED = "FEE_PLAN_FAILED";
// export const FEE_PLAN_REMOVE = "FEE_PLAN_REMOVE";
export const CLEAR_FEE_PLAN = "CLEAR_FEE_PLAN";

export const GET_PAYOUT_REPORTS_SUCCESS = "GET_PAYOUT_REPORTS_SUCCESS";
export const GET_PAYOUT_REPORTS_LOADING = "GET_PAYOUT_REPORTS_LOADING";
export const GET_PAYOUT_REPORTS_FAILED = "GET_PAYOUT_REPORTS_FAILED";
export const CLEAR_PAYOUT_REPORTS_LIST = "CLEAR_PAYOUT_REPORTS_LIST";

export const GET_POS_REPORTS_LOADING = "GET_POS_REPORTS_LOADING";
export const GET_POS_REPORTS_SUCCESS = "GET_POS_REPORTS_SUCCESS";
export const GET_POS_REPORTS_FAILED = "GET_POS_REPORTS_FAILED";
export const CLEAR_POS_REPORTS_LIST = "CLEAR_POS_REPORTS_LIST";

export const GET_MERCHANT_POS_LOADING = "GET_MERCHANT_POS_LOADING";
export const GET_MERCHANT_POS_SUCCESS = "GET_MERCHANT_POS_SUCCESS";
export const GET_MERCHANT_POS_FAILED = "GET_MERCHANT_POS_FAILED";
export const CLEAR_MERCHANT_POS = "CLEAR_MERCHANT_POS";

// payment schedule reducers

export const PAYMENT_SCHEDULE_LOADING = "PAYMENT_SCHEDULE_LOADING";
export const PAYMENT_SCHEDULE_SUCCESS = "PAYMENT_SCHEDULE_SUCCESS";
export const PAYMENT_SCHEDULE_FAILED = "PAYMENT_SCHEDULE_FAILED";
export const CLEAR_PAYMENT_SCHEDULE = "CLEAR_PAYMENT_SCHEDULE";

export const TRANSACTIONS_LOADING = "TRANSACTIONS_LOADING";
export const TRANSACTIONS_SUCCESS = "TRANSACTIONS_SUCCESS";
export const TRANSACTIONS_FAILED = "TRANSACTIONS_FAILED";
export const MERCHANT_TRANSACTIONS_SUCCESS = "MERCHANT_TRANSACTIONS_SUCCESS";
export const CLEAR_TRANSACTIONS = "CLEAR_TRANSACTIONS";

export const PAYOUT_CHILD_TRANSACTIONS_SUCCESS =
  "PAYOUT_CHILD_TRANSACTIONS_SUCCESS";
export const SINGLE_PAYOUT_TRANSACTIONS_SUCCESS =
  "SINGLE_PAYOUT_TRANSACTIONS_SUCCESS";
export const PAYOUT_CHILD_TRANSACTIONS_LOADING =
  "PAYOUT_CHILD_TRANSACTIONS_LOADING";
export const PAYOUT_CHILD_TRANSACTIONS_FAILED =
  "PAYOUT_CHILD_TRANSACTIONS_FAILED";
export const CLEAR_PAYOUT_CHILD_TRANSACTIONS =
  "CLEAR_PAYOUT_CHILD_TRANSACTIONS";

export const MERH_TRANSACTIONS_LOADING = "MERH_TRANSACTIONS_LOADING";
export const MERH_TRANSACTIONS_SUCCESS = "MERH_TRANSACTIONS_SUCCESS";
export const MERH_TRANSACTIONS_FAILED = "MERH_TRANSACTIONS_FAILED";

export const GET_VIRTUAL_ACCOUNTS_SUCCESS = "GET_VIRTUAL_ACCOUNTS_SUCCESS";
export const GET_VIRTUAL_ACCOUNTS_FAILED = "GET_VIRTUAL_ACCOUNTS_FAILED";
export const GET_VIRTUAL_ACCOUNTS_LOADING = "GET_VIRTUAL_ACCOUNTS_LOADING";
export const CLEAR_VIRTUAL_ACCOUNTS = "CLEAR_VIRTUAL_ACCOUNTS";

export const ADD_VIRTUAL_ACCOUNTS_SUCCESS = "ADD_VIRTUAL_ACCOUNTS_SUCCESS";
export const ADD_VIRTUAL_ACCOUNTS_FAILED = "ADD_VIRTUAL_ACCOUNTS_FAILED";
export const ADD_VIRTUAL_ACCOUNTS_LOADING = "ADD_VIRTUAL_ACCOUNTS_LOADING";
export const CLEAR_ADD_VIRTUAL_ACCOUNTS = "CLEAR_ADD_VIRTUAL_ACCOUNTS";

export const REPORT_TRANSACTIONS_LOADING = " REPORT_TRANSACTIONS_LOADING";
export const REPORT_TRANSACTIONS_SUCCESS = " REPORT_TRANSACTIONS_SUCCESS";
export const REPORT_TRANSACTIONS_FAILED = "REPORT_TRANSACTIONS_FAILED";

export const REPORT_STATS_LOADING = " REPORT_STATS_LOADING";
export const REPORT_STATS_SUCCESS = " REPORT_STATS_SUCCESS";
export const REPORT_STATS_FAILED = "REPORT_STATS_FAILED";

export const PAYOUT_AUDIT_LOADING = " PAYOUT_AUDIT_LOADING";
export const PAYOUT_AUDIT_SUCCESS = " PAYOUT_AUDIT_SUCCESS";
export const PAYOUT_AUDIT_FAILED = "PAYOUT_AUDIT_FAILED";
export const CLEAR_PAYOUT_AUDIT = "CLEAR_PAYOUT_AUDIT";

export const GET_AMSTHREATS_LOADING = "GET_AMSTHREATS_LOADING";
export const GET_AMSTHREATS_SUCCESS = "GET_AMSTHREATS_SUCCESS";
export const GET_AMSTHREATS_FAILED = "GET_AMSTHREATS_FAILED";
export const GET_AMSTHREATS_REMOVE = "GET_AMSTHREATS_REMOVE";

export const GET_SummaryThreatsFromMerchantControl_LOADING =
  "GET_SummaryThreatsFromMerchantControl_LOADING";
export const GET_SummaryThreatsFromMerchantControl_SUCCESS =
  "GET_SummaryThreatsFromMerchantControl_SUCCESS";
export const GET_SummaryThreatsFromMerchantControl_FAILED =
  "GET_SummaryThreatsFromMerchantControl_FAILED";
export const GET_SummaryThreatsFromMerchantControl_REMOVE =
  "GET_SummaryThreatsFromMerchantControl_REMOVE";

export const GET_Top3DetectionNameFromMerchantControl_LOADING =
  "GET_Top3DetectionNameFromMerchantControl_LOADING";
export const GET_Top3DetectionNameFromMerchantControl_SUCCESS =
  "GET_Top3DetectionNameFromMerchantControl_SUCCESS";
export const GET_Top3DetectionNameFromMerchantControl_FAILED =
  "GET_Top3DetectionNameFromMerchantControl_FAILED";
export const GET_Top3DetectionNameFromMerchantControl_REMOVE =
  "GET_Top3DetectionNameFromMerchantControl_REMOVE";

export const GET_Top5TerminalIdFromMerchantControl_LOADING =
  "GET_Top5TerminalIdFromMerchantControl_LOADING";
export const GET_Top5TerminalIdFromMerchantControl_SUCCESS =
  "GET_Top5TerminalIdFromMerchantControl_SUCCESS";
export const GET_Top5TerminalIdFromMerchantControl_FAILED =
  "GET_Top5TerminalIdFromMerchantControl_FAILED";
export const GET_Top5TerminalIdFromMerchantControl_REMOVE =
  "GET_Top5TerminalIdFromMerchantControl_REMOVE";

export const GET_DataByDateFromMerchantControl_LOADING =
  "GET_DataByDateFromMerchantControl_LOADING";
export const GET_DataByDateFromMerchantControl_SUCCESS =
  "GET_DataByDateFromMerchantControl_SUCCESS";
export const GET_DataByDateFromMerchantControl_FAILED =
  "GET_DataByDateFromMerchantControl_FAILED";
export const GET_DataByDateFromMerchantControl_REMOVE =
  "GET_DataByDateFromMerchantControl_REMOVE";

export const GET_SDKLOGINTOKEN_LOADING = "GET_SDKLOGINTOKEN_LOADING";
export const GET_SDKLOGINTOKEN_SUCCESS = "GET_SDKLOGINTOKEN_SUCCESS";
export const GET_SDKLOGINTOKEN_FAILED = "GET_SDKLOGINTOKEN_FAILED";
export const GET_SDKLOGINTOKEN_REMOVE = "GET_SDKLOGINTOKEN_REMOVE";

export const SET_SELECTED_MERCHANT_REGISTRATION_DATA =
  "SET_SELECTED_MERCHANT_REGISTRATION_DATA";
export const REMOVE_SELECTED_MERCHANT_REGISTRATION_DATA =
  "REMOVE_SELECTED_MERCHANT_REGISTRATION_DATA";

//get TransactionTypes list
export const GET_ALLTRANSACTIONTYPES_LOADING =
  "GET_ALLTRANSACTIONTYPES_LOADING";
export const GET_ALLTRANSACTIONTYPES_SUCCESS =
  "GET_ALLTRANSACTIONTYPES_SUCCESS";
export const GET_ALLTRANSACTIONTYPES_FAILED = "GET_ALLTRANSACTIONTYPES_FAILED";

//get payment scheme list
export const GET_ALLPAYMENTSCHEME_LOADING = "GET_ALLPAYMENTSCHEME_LOADING";
export const GET_ALLPAYMENTSCHEME_SUCCESS = "GET_ALLPAYMENTSCHEME_SUCCESS";
export const GET_ALLPAYMENTSCHEME_FAILED = "GET_ALLPAYMENTSCHEME_FAILED";

//get refund payment config list
export const GET_MERCHANTREFUNDPAYMENTCONFIG_LOADING =
  "GET_MERCHANTREFUNDPAYMENTCONFIG_LOADING";
export const GET_MERCHANTREFUNDPAYMENTCONFIG_SUCCESS =
  "GET_MERCHANTREFUNDPAYMENTCONFIG_SUCCESS";
export const GET_MERCHANTREFUNDPAYMENTCONFIG_FAILED =
  "GET_MERCHANTREFUNDPAYMENTCONFIG_FAILED";

export const UPDATE_MERCHANTREFUNDPAYMENTCONFIG_LOADING =
  "UPDATE_MERCHANTREFUNDPAYMENTCONFIG_LOADING";
export const UPDATE_MERCHANTREFUNDPAYMENTCONFIG_SUCCESS =
  "UPDATE_MERCHANTREFUNDPAYMENTCONFIG_SUCCESS";
export const UPDATE_MERCHANTREFUNDPAYMENTCONFIG_FAILED =
  "UPDATE_MERCHANTREFUNDPAYMENTCONFIG_FAILED";

export const GET_USERREFUNDPAYMENTCONFIGBYMERCHANT_LOADING =
  "GET_USERREFUNDPAYMENTCONFIGBYMERCHANT_LOADING";
export const GET_USERREFUNDPAYMENTCONFIGBYMERCHANT_SUCCESS =
  "GET_USERREFUNDPAYMENTCONFIGBYMERCHANT_SUCCESS";
export const GET_USERREFUNDPAYMENTCONFIGBYMERCHANT_FAILED =
  "GET_USERREFUNDPAYMENTCONFIGBYMERCHANT_FAILED";

export const UPDATE_USERREFUNDPAYMENTCONFIGBYMERCHANT_LOADING =
  "UPDATE_USERREFUNDPAYMENTCONFIGBYMERCHANT_LOADING";
export const UPDATE_USERREFUNDPAYMENTCONFIGBYMERCHANT_SUCCESS =
  "UPDATE_USERREFUNDPAYMENTCONFIGBYMERCHANT_SUCCESS";
export const UPDATE_USERREFUNDPAYMENTCONFIGBYMERCHANT_FAILED =
  "UPDATE_USERREFUNDPAYMENTCONFIGBYMERCHANT_FAILED";

export const MPGS_LOADING = "MPGS_LOADING";
export const MPGS_SUCCESS = "MPGS_SUCCESS";
export const MPGS_FAILED = "MPGS_FAILED";
export const MPGS_REMOVE = "MPGS_REMOVE";
